import { render, staticRenderFns } from "./KlasifikasiPemohon.vue?vue&type=template&id=5fd1607b&"
import script from "./KlasifikasiPemohon.vue?vue&type=script&lang=js&"
export * from "./KlasifikasiPemohon.vue?vue&type=script&lang=js&"
import style0 from "./KlasifikasiPemohon.vue?vue&type=style&index=0&id=5fd1607b&prod&lang=css&"
import style1 from "./KlasifikasiPemohon.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports